import { render, staticRenderFns } from "./aidaAccountSet.vue?vue&type=template&id=3bf477df&scoped=true&"
import script from "./aidaAccountSet.vue?vue&type=script&lang=js&"
export * from "./aidaAccountSet.vue?vue&type=script&lang=js&"
import style0 from "./aidaAccountSet.vue?vue&type=style&index=0&id=3bf477df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf477df",
  null
  
)

export default component.exports